(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.jQuery) return;

    var headerConfig = document.querySelector('.header-fixed');
    if (!headerConfig) return;

    var $ = window.jQuery;
    var $window = $(window);
    var $header = $('.header-fixed');
    var $headerSection = $('#shopify-section-header');
    var $body = $('body');
    var isHomePage = headerConfig.getAttribute('data-header-is-home') === 'true';
    var isProductPage = headerConfig.getAttribute('data-header-is-product') === 'true';
    var hasCollectionImage = headerConfig.getAttribute('data-header-has-collection-image') === 'true';
    var enableHeaderEffects = headerConfig.getAttribute('data-header-effects-enabled') === 'true';
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var shouldBeTransparent = isHomePage || hasCollectionImage || (isProductPage && isMobile);
    var solidHeaderScrollOffset = 140;
    var transparentHeaderScrollOffset = 90;
    var logoHideScrollOffset = 60;
    var logoScrollDelta = 8;
    var isSolidHeader = false;
    var lastScrollTop = $window.scrollTop();

    function setHeaderSectionHeight() {
      if (enableHeaderEffects && hasCollectionImage) {
        $headerSection.height(0);
      } else if (enableHeaderEffects && shouldBeTransparent && $header.hasClass('header-fixed--transparent')) {
        $headerSection.height(0);
      } else {
        $headerSection.height($header.outerHeight());
      }
    }

    function applyHeaderState() {
      if (!enableHeaderEffects || !shouldBeTransparent) {
        return;
      }

      var currentTop = $window.scrollTop();
      var nextSolidState = isSolidHeader;

      if (!isSolidHeader && currentTop > solidHeaderScrollOffset) {
        nextSolidState = true;
      } else if (isSolidHeader && currentTop < transparentHeaderScrollOffset) {
        nextSolidState = false;
      }

      if (nextSolidState !== isSolidHeader) {
        isSolidHeader = nextSolidState;

        if (isSolidHeader) {
          $header.addClass('resized');
          $header.removeClass('header-fixed--transparent');
          $body.removeClass('header-is-transparent');
        } else {
          $header.removeClass('resized');
          $header.addClass('header-fixed--transparent');
          $body.addClass('header-is-transparent');
        }

        setHeaderSectionHeight();
      }
    }

    function applyLogoScrollState() {
      if (!enableHeaderEffects) {
        return;
      }

      var currentTop = $window.scrollTop();

      if (currentTop > 5) {
        $header.addClass('header-fixed--logo-hidden');
      } else {
        $header.removeClass('header-fixed--logo-hidden');
      }

      lastScrollTop = currentTop;
    }

    $body.toggleClass('header-effects-enabled', enableHeaderEffects && shouldBeTransparent);

    if (!enableHeaderEffects) {
      isSolidHeader = true;
      $header.removeClass('header-fixed--logo-hidden');
      $header.addClass('resized');
      $header.removeClass('header-fixed--transparent');
      $body.removeClass('header-is-transparent');
    } else if (!shouldBeTransparent) {
      isSolidHeader = true;
      $header.removeClass('header-fixed--logo-hidden');
      $header.addClass('resized');
      $header.removeClass('header-fixed--transparent');
      $body.removeClass('header-is-transparent');
    } else {
      if ($window.scrollTop() > solidHeaderScrollOffset) {
        isSolidHeader = true;
        $header.addClass('resized');
        $header.removeClass('header-fixed--transparent');
        $body.removeClass('header-is-transparent');
      } else {
        isSolidHeader = false;
        $header.removeClass('resized');
        $header.addClass('header-fixed--transparent');
        $body.addClass('header-is-transparent');
      }
    }

    setHeaderSectionHeight();
    applyLogoScrollState();

    $window.on('scroll', function () {
      applyHeaderState();
      applyLogoScrollState();
    });

    $window.on('resize', function () {
      var wasMobile = isMobile;
      isMobile = window.matchMedia('(max-width: 749px)').matches;
      shouldBeTransparent = isHomePage || hasCollectionImage || (isProductPage && isMobile);

      if (wasMobile !== isMobile && isProductPage) {
        /* Switched breakpoint on product page - re-apply header state */
        $body.toggleClass('header-effects-enabled', enableHeaderEffects && shouldBeTransparent);
        if (shouldBeTransparent && enableHeaderEffects && $window.scrollTop() <= transparentHeaderScrollOffset) {
          isSolidHeader = false;
          $header.removeClass('resized');
          $header.addClass('header-fixed--transparent');
          $body.addClass('header-is-transparent');
        } else {
          isSolidHeader = true;
          $header.addClass('resized');
          $header.removeClass('header-fixed--transparent');
          $body.removeClass('header-is-transparent');
        }
      }

      setHeaderSectionHeight();
    });

    $('.site-nav--has-dropdown').on('mouseenter', function () {
      $('.site-nav__dropdown').css({paddingTop: ($('.header-fixed').outerHeight()+30)+'px'})
    })
  });
})();
